module.exports = __webpack_public_path__ + "img/liugeyi.a94b9961.png";